import { jsx as _jsx } from "react/jsx-runtime";
import { RenderCategoryPageLayoutElements } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/RenderCategoryPageLayoutElements";
import { useCategoryLayoutElementsLoadTiming } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useCategoryLayoutElementsLoadTiming";
import { useGetCategoryPageLayoutElementsByPlacement } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useGetCategoryPageLayoutElementsByPlacement";
import React from "react";
export var CategoryPageLayoutElements = function(param) {
    var placement = param.placement, hubCategoryPageLoadTimingRef = param.hubCategoryPageLoadTimingRef;
    var getCategoryPageLayoutElementsByPlacement = useGetCategoryPageLayoutElementsByPlacement();
    var layoutElements = getCategoryPageLayoutElementsByPlacement(placement);
    useCategoryLayoutElementsLoadTiming(placement);
    return /*#__PURE__*/ _jsx("div", {
        ref: hubCategoryPageLoadTimingRef,
        children: /*#__PURE__*/ _jsx(RenderCategoryPageLayoutElements, {
            layoutElements: layoutElements
        })
    });
};
